import * as Yup from 'yup'

export interface AccuracyProps {
  accuracy1?: boolean
  accuracy2?: boolean
}

export interface ICreateAccount {
  investors?: string
  typePage?: string
  static?: string
  phoneNumber: string
  personalEmail?: string
  tax_cd?: string
  brch_cd?: string
  idno?: string
  idno_iss_dt?: string
  placeCap?: string
  cust_nm?: string
  birth_dt?: string
  sex_tp?: string
  home_addr?: string
  conct_addr?: string
  accuracy?: boolean
  fatca_yn?: boolean
  NHSVBranch?: string
  acnt_mrgn_tp?: boolean
  acnt_dr_tp?: boolean
  trd_onl_yn?: boolean
  cert_tp?: boolean
  otp_recv_tp?: boolean
  auto_pia_tp?: boolean
  sms_tp?: string
  rcm_emp_no_tp?: string
  email_yn?: boolean
  ifno_idno?: string
  mng_emp_yn?: string
  mng_emp_no?: string
  bank_cd_off_1?: string
  bank_brch_cd_1?: string
  bank_cd_off_2?: string
  bank_brch_cd_2?: string
  bank_cd_off_3?: string
  bank_brch_cd_3?: string
  bank_acnt_no_1?: string
  bank_acnt_nm_1?: string
  bank_acnt_no_2?: string
  bank_acnt_nm_2?: string
  bank_acnt_no_3?: string
  bank_acnt_nm_3?: string
  investmentGoals?: string
  levelOfRisk?: string
  experienceKnowledge?: string
  customerIsAnInternal?: boolean
  customerIsAnInternalNameCompany?: string
  customerIsAnInternalStockCode?: string
  customerIsAnInternalRank?: string
  customersOwnHave5?: boolean
  customerIsAnInternalNameCompany5?: string
  customerIsAnInternalStockCode5?: string
  customerIsAnInternalRank5?: string
  informationAboutoOners?: boolean
  infFullname?: string
  infBirth?: string
  infNational?: string
  infCccd?: string
  infDateRange?: string
  infIssued?: string
  infPermanentAddress?: string
  infAddress?: string
  infJob?: string
  idno_iss_orga?: string
  infPosition?: string
  infPhone?: string
  inforVisaNumber?: string
  infAddressRegistered?: string
  haveReadHD?: boolean
  ivmt_goal_tp?: string
  risk_tp?: string
  exp_yn?: string
  internal_cpny_nm_1?: string
  internal_cpny_nm_2?: string
  internal_stk_1?: string
  internal_stk_2?: string
  internal_position_1?: string
  internal_position_2?: string
  own_cpny_nm_1?: string
  own_cpny_nm_2?: string
  own_stk_1?: string
  own_stk_2?: string
  own_position_1?: string
  own_position_2?: string
  bo_fullname?: string
  bo_dob?: string
  bo_nationality?: string
  bo_idno?: string
  bo_idno_iss_dt?: string
  bo_idno_iss_orga?: string
  bo_home_addr?: string
  bo_conct_addr?: string
  bo_job?: string
  bo_position?: string
  bo_phone_no?: string
  bo_visa_no?: string
  bo_visano_iss_orga?: string
  bo_foreign_residence?: string
  occupation: string
  [key: string]: any
}

const formatPhoneNum = /^\+?((84)|0)(3|5|7|8|9)[0-9]{8}$/
const validateTaxCode = /^(?=.*[1-9])[0-9]{1,20}$/
const validateBank = /^[a-zA-Z0-9]{1,20}$/
const validateConctAddr = /^.{27,}$/
const forbiddenOccupationChars = /[!@#$%^&*+{}<>]/

const indentify = /^(?:\d{9}|\d{12})$/

const createAccountSchemas = [
  Yup.object({
    personalEmail: Yup.string()
      .email('Địa chỉ email không đúng định dạng')
      .required('Vui lòng điền vào địa chỉ email'),
    phoneNumber: Yup.string()
      .required('Vui lòng điền vào số điện thoại')
      .matches(formatPhoneNum, 'Số điện thoại không đúng định dạng'),
    tax_cd: Yup.string().matches(validateTaxCode, 'Mã số thuế không đúng định dạng'),
    occupation: Yup.string()
      .trim()
      .required('Vui lòng điền vào nghề nghiệp')
      .max(50, 'Không được vượt quá 50 ký tự')
      .test(
        'no-special-chars',
        'Không chứa ký tự đặc biệt ! @ # $ % ^ & * + { } < >',
        (value) => !forbiddenOccupationChars.test(value || '')
      ),
  }),
  Yup.object({}),
  Yup.object({}),
  Yup.object({}),
  Yup.object({}),
  Yup.object({
    // conct_addr: Yup.string().matches(validateConctAddr, 'Địa chỉ liên hệ ít nhất 27 ký tự'),
  }),
  Yup.object({
    // brch_cd: Yup.string().required('Trường này bắt buộc'),
    // acnt_mrgn_tp: Yup.string().required('Trường này bắt buộc'),
    sms_tp: Yup.string().required('Trường này bắt buộc'),
    mng_emp_yn: Yup.string().required('Trường này bắt buộc'),
    rcm_emp_no_tp: Yup.string().required('Trường này bắt buộc'),
    ifno_idno: Yup.string()
      .required('Trường này bắt buộc')
      .when('rcm_emp_no_tp', {
        is: '2',
        then: (schema) =>
          schema
            .required('Trường này bắt buộc')
            .matches(indentify, 'Nhập số CMND/ CCCD là số có 9 hoặc 12 chữ số'),
      }),
    mng_emp_no: Yup.string().when('mng_emp_yn', {
      is: 'Y',
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
  }),
  Yup.object({
    bank_cd_off_1: Yup.string().required('Vui lòng chọn tên ngân hàng'),
    bank_brch_cd_1: Yup.string().required('Vui lòng chọn chi nhánh ngân hàng'),
    bank_acnt_no_1: Yup.string()
      .required('Vui lòng điền vào Số tài khoản')
      .matches(validateBank, 'Số tài khoản không đúng định dạng'),
    bank_acnt_no_2: Yup.string().matches(validateBank, 'Số tài khoản không đúng định dạng'),
    bank_acnt_no_3: Yup.string().matches(validateBank, 'Số tài khoản không đúng định dạng'),
  }),
  Yup.object({
    internal_cpny_nm_1: Yup.string().when('customerIsAnInternal', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    internal_stk_1: Yup.string().when('customerIsAnInternal', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    internal_position_1: Yup.string().when('customerIsAnInternal', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    own_cpny_nm_1: Yup.string().when('customersOwnHave5', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    own_stk_1: Yup.string().when('customersOwnHave5', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    own_position_1: Yup.string().when('customersOwnHave5', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    bo_fullname: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    bo_dob: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    bo_nationality: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    bo_idno: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) =>
        schema
          .required('Trường này bắt buộc')
          .matches(indentify, 'Nhập số CMND/ CCCD là số có 9 hoặc 12 chữ số'),
    }),
    bo_idno_iss_dt: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    bo_idno_iss_orga: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    bo_home_addr: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    bo_conct_addr: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    bo_job: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    bo_position: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    bo_phone_no: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) =>
        schema
          .required('Trường này bắt buộc')
          .matches(formatPhoneNum, 'Số điện thoại không đúng định dạng'),
    }),
    bo_visa_no: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
    bo_visano_iss_orga: Yup.string().when('informationAboutoOners', {
      is: true,
      then: (schema) => schema.required('Trường này bắt buộc'),
    }),
  }),
  Yup.object({
    haveReadHD: Yup.boolean().oneOf([true], 'Please check the box to open account'),
  }),
]

const inits: ICreateAccount = {
  investors: '1',
  static: 'vietnam',
  typePage: '',
  phoneNumber: '',
  personalEmail: '',
  tax_cd: '',
  idno: '',
  idno_iss_dt: '',
  placeCap: '1',
  cust_nm: '',
  brch_cd: '100',
  birth_dt: '',
  sex_tp: '',
  home_addr: '',
  idno_iss_orga: '',
  conct_addr: '',
  accuracy: false,
  NHSVBranch: '1',
  acnt_mrgn_tp: false,
  acnt_dr_tp: false,
  trd_onl_yn: true,
  cert_tp: true,
  otp_recv_tp: true,
  auto_pia_tp: false,
  sms_tp: '',
  email_yn: false,
  fatca_yn: true,
  rcm_emp_no_tp: '',
  ifno_idno: '',
  mng_emp_yn: '',
  mng_emp_no: undefined,
  bank_cd_off_1: '',
  bank_brch_cd_1: '',
  bank_cd_off_2: undefined,
  bank_brch_cd_2: undefined,
  bank_cd_off_3: undefined,
  bank_brch_cd_3: undefined,
  bank_acnt_no_1: '',
  bank_acnt_nm_1: '',
  bank_acnt_no_2: undefined,
  bank_acnt_nm_2: undefined,
  bank_acnt_no_3: undefined,
  bank_acnt_nm_3: undefined,
  customerIsAnInternal: false,
  haveReadHD: false,
  ivmt_goal_tp: undefined,
  risk_tp: undefined,
  exp_yn: undefined,
  internal_cpny_nm_1: undefined,
  internal_cpny_nm_2: undefined,
  internal_stk_1: undefined,
  internal_stk_2: undefined,
  internal_position_1: undefined,
  internal_position_2: undefined,
  own_cpny_nm_1: undefined,
  own_cpny_nm_2: undefined,
  own_stk_1: undefined,
  own_stk_2: undefined,
  own_position_1: undefined,
  own_position_2: undefined,
  customersOwnHave5: false,
  informationAboutoOners: false,
  //-----------------------------
  bo_fullname: undefined,
  bo_dob: undefined,
  bo_nationality: undefined,
  bo_idno: undefined,
  bo_idno_iss_dt: undefined,
  bo_idno_iss_orga: undefined,
  bo_home_addr: undefined,
  bo_conct_addr: undefined,
  bo_job: undefined,
  bo_position: undefined,
  bo_phone_no: undefined,
  bo_visa_no: undefined,
  bo_visano_iss_orga: undefined,
  bo_foreign_residence: undefined,
  occupation: '',
}

export {createAccountSchemas, inits}
